// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Meta from 'vue-meta'
import store from './store/store'


window.Vue = Vue
Vue.config.productionTip = false

//window.$ = require('jquery')

Vue.use(Meta)


//Cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies, { expire: '7d' })

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);
//================feather icons==================//
import VueFeather from 'vue-feather';
Vue.use(VueFeather);
//================ Carousel 3d==================//
import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);

// import { FunctionalCalendar } from 'vue-functional-calendar';
// Vue.component('FunctionalCalendar',FunctionalCalendar);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import Datepicker from 'vue2-datepicker';
Vue.component('datepicker', Datepicker)

import Datepicker1 from 'vuejs-datepicker';
Vue.component('datepicker1', Datepicker1)


import loader from '@/components/website/shared/loader'
Vue.component('loader', loader)

import message from '@/components/website/shared/message'
Vue.component('message', message)

import giniViewMixins from './plugins/giniView/index.ts';
Vue.mixin(giniViewMixins);

Vue.prototype.$env_var = process.env

//================Mouse Paralles ==================//



new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js